// https://medium.com/@mudasarmajeed5/creating-a-reusable-confirm-dialog-with-promise-based-api-in-next-js-15-shadcn-ui-78865935077e

'use client';

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ConfirmDialogProps {
    title?: string;
    description?: string;
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function ConfirmDialog({
    title = "Confirmez",
    description = "Etes-vous sûr ?",
    isOpen,
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={onCancel}>Annuler</Button>
                    <Button onClick={onConfirm}>Confirmer</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}